const SEARCH_UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Shared UUID helper for validated route search extras (e.g. `?view=`). */
export function parseSearchUuid(value: unknown): string | undefined {
  if (typeof value !== 'string') return undefined;
  const trimmed = value.trim();
  return SEARCH_UUID_RE.test(trimmed) ? trimmed : undefined;
}
